module.exports = __webpack_public_path__ + "img/laptop-cat1.ffd64937.jpg";